import { Component, CUSTOM_ELEMENTS_SCHEMA, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { RepairLocationSearchTextForm } from '../../../form-model/repair-location-search-text.form.model';
import '@maersk-global/mds-components-core/mc-input';

@Component({
  selector: 'app-repair-location-search',
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule],
  templateUrl: './repair-location-search.component.html',
  styleUrl: './repair-location-search.component.scss',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class RepairLocationSearchComponent implements OnInit {
  @Input({ required: true }) repairLocationSearchTextForm!: FormGroup<RepairLocationSearchTextForm>;

  constructor(private readonly formBuilder: FormBuilder) {}

  ngOnInit(): void {
    this.addControlsToTheFormGroup();
  }

  applySearchTextFilters(): void {
    this.repairLocationSearchTextForm.controls.appliedRepairLocationSearchTextFilter.setValue(true);
  }

  isControlInErrorState(control: FormControl): boolean | null {
    return control.invalid && control.touched ? true : null;
  }

  private addControlsToTheFormGroup(): void {
    this.repairLocationSearchTextForm.addControl('SearchText', this.formBuilder.control<string | null>(null));
    this.repairLocationSearchTextForm.addControl(
      'appliedRepairLocationSearchTextFilter',
      this.formBuilder.control<boolean | null>(null),
    );
  }
}
